// extracted by mini-css-extract-plugin
export var alpha = "_87-4";
export var alphaInputContainer = "_87-f";
export var badge = "_87-b";
export var brandKitGrid = "_87-h";
export var brandKitItem = "_87-i";
export var brandKitSwatch = "_87-j";
export var controls = "_87-5";
export var formatDropdown = "_87-d";
export var formatSelector = "_87-c";
export var hex = "_87-6";
export var hexInput = "_87-e";
export var hue = "_87-3";
export var hueAndAlphaPointer = "_87-a";
export var percentageLabel = "_87-g";
export var picker = "_87-0";
export var rgba = "_87-8";
export var rgbaSection = "_87-7";
export var saturation = "_87-1";
export var saturationPointer = "_87-9";
export var sliders = "_87-2";